import { useEffect, type CSSProperties, type ReactNode } from "react";
import { resolveBranding } from "../../config/branding";

interface Props {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}

export function AuthLayout({ title, subtitle, children, footer }: Props) {
  const branding = resolveBranding();

  // Reflect branding on the document while on auth screens — AppLayout takes
  // over once the user is signed in.
  useEffect(() => {
    document.title = `${title} · ${branding.productName}`;
    if (!branding.favicon) return;
    let link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = branding.favicon;
  }, [title, branding.productName, branding.favicon]);

  const accentStyle = branding.accent
    ? ({
        "--accent": branding.accent,
        "--accent-strong": branding.accent,
      } as CSSProperties)
    : undefined;

  return (
    <main className="auth-shell" style={accentStyle}>
      <div className="auth-card">
        <div className="brand">
          {branding.logo ? (
            <img className="brand-logo" src={branding.logo} alt={branding.productName} />
          ) : (
            <div className="dot" />
          )}
          <span>{branding.productName}</span>
        </div>
        <h1>{title}</h1>
        {subtitle ? <p className="subtitle">{subtitle}</p> : null}
        {children}
        {footer ? <div className="auth-footer">{footer}</div> : null}
      </div>
    </main>
  );
}
